import { createSelector } from 'reselect';

export const selectNotify = (state) => state.notify;
